<template src="./ProductCreateComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {useAccountStore} from "@/stores/account.js";
import {AppConstant} from "@/supports/app.constant";
import {ref, computed, onMounted, watchEffect, watch} from "vue";
import CommonService from "@/services/common.service.ts";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import {ErrorMessageConstant, ErrorText} from "@/supports/error-message.constant.ts";
import {useProductStore} from "@/stores/product.js";
import InputTextareaNormal from "@/components/inputs/input-textarea/normal/InputTextareaNormal.vue";
import {useRoute, useRouter} from "vue-router";
import {useWarehouseStore} from "@/stores/warehouse.js";
import {useStore} from "@/stores/store.js";
export default {
  name: 'ProductCreateComponent',
  components: {
    InputTextareaNormal,
    ButtonAddComponent,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome},
  setup() {
    const errors = ref(true)
    const mode = ref('create')
    const product_id = ref(null)
    const labelButtonSetting = ref('Tạo sản phẩm')
    const usingWarehouse = ref(null)
    const productDetail = ref({})
    const dataProduct = ref({
      product_name: {
        id: 'product_name',
        label: 'Tên sản phẩm',
        placeholder: 'Tên sản phẩm',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required', ['maxLength', 254]]
      },
      warehouse_id: {
        id: 'warehouse_id',
        label: 'Kho hàng',
        placeholder: 'Kho hàng',
        value: '',
        error: '',
        isError: false,
        required: true,
        options: [],
        validations: ['required']
      },
      product_code: {
        id: 'product_code',
        label: 'Mã sản phẩm',
        placeholder: 'Mã sản phẩm',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required', ['maxLength', 7]]
      },
      product_quantity: {
        id: 'product_quantity',
        label: 'Số lượng',
        placeholder: 'Số lượng',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required', 'naturalNumber']
      },
      product_price: {
        id: 'product_price',
        label: 'Giá sản phẩm',
        placeholder: 'Giá sản phẩm',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required', 'decimal']
      },
      product_selling_price: {
        id: 'product_selling_price',
        label: 'Giá bán sản phẩm',
        placeholder: 'Giá bán sản phẩm',
        value: '',
        error: '',
        isError: false,
        required: true,
        validations: ['required', 'decimal']
      },
      product_unit: {
        id: 'product_unit',
        label: 'Đơn vị sản phẩm',
        placeholder: 'Đơn vị sản phẩm',
        value: '',
        error: '',
        isError: false,
        required: false,
      },
      product_tax: {
        id: 'product_tax',
        label: 'Thuế',
        placeholder: 'Thuế',
        value: '0',
        error: '',
        isError: false,
        required: false,
      },
      product_description: {
        id: 'product_description',
        label: 'Mô tả sản phẩm',
        placeholder: 'Mô tả sản phẩm',
        value: '',
        error: '',
        isError: false,
        required: false
      },
    })
    const router = useRouter()
    const route = useRoute()
    const productStore = useProductStore()
    const accountStore = useAccountStore()
    const warehouseStore = useWarehouseStore()

    onMounted(() => {
      mode.value = route.params.mode;
      if(!warehouseStore.warehouses.length) {
        getListWarehouses();
      }else {
        warehouseStore.warehouses.forEach((item) => {
          dataProduct.value.warehouse_id.options.push({
            name: item.name,
            value: item.id
          })
        })
      }

      if(mode.value === 'detail') {
        labelButtonSetting.value = 'Cập nhập sản phẩm';
        product_id.value =  route.params.id;
        getDataProductDetail();
      }
    });

    watch(() => productStore.product, (newProduct) => {
      productDetail.value = newProduct
      dataProduct.value.product_name.value = newProduct.product_name;
      dataProduct.value.product_code.value = newProduct.product_code;
      dataProduct.value.product_price.value = newProduct.product_price;
      dataProduct.value.product_quantity.value = newProduct.product_quantity;
      dataProduct.value.product_selling_price.value = newProduct.product_selling_price;
      dataProduct.value.product_description.value = newProduct.product_description;
      dataProduct.value.product_tax.value = newProduct.product_tax;
      dataProduct.value.product_unit.value = newProduct.product_unit;
    });

    function validateForm(value, name) {
      const hasError = CommonService.validateForm(value, name, dataProduct)
      const field = dataProduct.value[name]
      if (!field) return hasError

      return hasError
    }


    async function createOrUpdateProduct() {
      errors.value = false
      for (const key in dataProduct.value) {
        const hasError = validateForm(dataProduct.value[key].value, key)
        if (hasError) errors.value = true
      }
      if(!errors.value) {
        const params = {
          m_company_id: accountStore.account.company.id,
          product_name: dataProduct.value.product_name.value,
          product_code: dataProduct.value.product_code.value,
          product_quantity: dataProduct.value.product_quantity.value,
          product_price: dataProduct.value.product_price.value,
          product_selling_price: dataProduct.value.product_selling_price.value,
          product_unit: dataProduct.value.product_unit.value,
          product_tax: Number(dataProduct.value.product_tax.value) || 0,
          product_description: dataProduct.value.product_description.value,
          warehouse_id: dataProduct.value.warehouse_id.value,
        }
        let url = AppConstant.URL_API_LOCAL + 'api/product/create-product';
        if(mode.value === 'detail') {
          params.id = product_id.value;
          url = AppConstant.URL_API_LOCAL + 'api/product/update-product';
        }
        const product = await productStore.createOrUpdateProduct(url, params);
        await CommonService.showAlertPopup({
          title: product?.message,
          icon: "success",
          showConfirmButton: false,
          timer: 1000,
          width: '800px'
        });

        await router.push('/product')
      }
    }

    async function getListWarehouses() {
      const params = {
        id: accountStore.account.company.id,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/warehouse/list-warehouse';
      await warehouseStore.getListWarehouses(url, params);
      warehouseStore.warehouses.forEach((warehouse) => {
        dataProduct.value.warehouse_id.options.push({
          name: warehouse.name,
          value: warehouse.id
        })
      })
    }

    function getDataProductDetail() {
      const params = {
        company_id: accountStore.account.company.id,
        product_id: product_id.value,
        warehouse_id: warehouseStore.usingWarehouse.id
      }
      const url = AppConstant.URL_API_LOCAL + 'api/product/detail';
      productStore.getProductDetail(url, params);
    }
    function onChange(value, name) {
      dataProduct.value[name].value = value
    }

    const listProducts = computed(() => {
      return productStore.products;
    });


    return {
      createOrUpdateProduct,
      listProducts,
      dataProduct,
      mode,
      usingWarehouse,
      labelButtonSetting,
      CommonService,
      errors,
      onChange,
      validateForm,
    }
  },
}
</script>
<style lang="scss">
.dashboard-page {
  margin-top: 80px;
  margin-left: 80px;
  height: 100%;
  .title-page {
    padding: 15px 30px;
    background-color: #fff;
  }
  .container-fluid {
    padding-top: 30px;
    .card {
      margin-bottom: 30px;
      letter-spacing: .5px;
      box-shadow: 0 9px 20px rgba(46,35,94,.07);
      .card-body {
        padding: 30px;
        border-radius: 15px;
        background-color: #ffffff;
        .btn-invite-partner {
          width: 150px;
          margin-top: 50px;
        }
        .list-partners-component {
          margin-top: 30px;
          .label_priority {
            padding: 5px;
            border: 1px solid #f73164;
            border-radius: 5px;
            max-width: 120px;
            width: 120px;
            display: flex;
            align-content: center;
            justify-content: center;
            color: #ffffff;
          }
          td.action {
            display: flex;
            justify-content: center;
            gap: 20px;
            .item-action {
              width: 20px;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>
